import { render } from "./ProjectSingle.vue?vue&type=template&id=e9c16ea6&scoped=true"
import script from "./ProjectSingle.vue?vue&type=script&lang=js"
export * from "./ProjectSingle.vue?vue&type=script&lang=js"

import "./ProjectSingle.vue?vue&type=style&index=0&id=e9c16ea6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c16ea6"]])

export default __exports__